import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const a = s((i, e) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: e,
    ...i,
    image: (o) => /* @__PURE__ */ l.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ l.jsx("g", { clipPath: "url(#clip0_3410_69080)", children: /* @__PURE__ */ l.jsx(
            "path",
            {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3 16a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1zm1-6V2h8v8zm1 4h6v-2H5z",
              clipRule: "evenodd"
            }
          ) }),
          /* @__PURE__ */ l.jsx("defs", { children: /* @__PURE__ */ l.jsx("clipPath", { id: "clip0_3410_69080", children: /* @__PURE__ */ l.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "PostcardIcon";
export {
  a as PostcardIcon,
  a as default
};
//# sourceMappingURL=index.js.map
